import React, { useState } from 'react';
import useAuthService from 'src/shared/hooks/useAuthService';
import { TertiaryButton, PrimaryButton } from 'src/shared/components/button/Button';
import { Dialog, DialogContent, DialogTitle, DialogFooter } from 'src/shared/components/ui/dialog';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import authStorageService from 'src/shared/hooks/services/auth-storage-service';
import { UserGroup } from 'src/shared/types';
import NestedSidebarMenuItem from './NestedSidebarMenuItem';

const UserMenu = () => {
    const [shouldShowConfirmation, showConfirmation] = useState(false);
    const { currentUser, signout } = useAuthService();
    const navigate = useAppNavigation();
    const hasImpersonatePermission = currentUser?.groups?.includes(UserGroup.IMPERSONATOR);

    if (!currentUser) {
        return null;
    }

    const initials = (currentUser.firstName[0] || '') + (currentUser.lastName[0] || '');
    const fullName = currentUser.firstName + ' ' + currentUser.lastName;

    const subItems = [
        {
            title: 'Add Passkey',
            href: navigate.paths.addPasskeyUrl(),
            onClick: () => authStorageService.clearAll(),
        },
        ...(hasImpersonatePermission
            ? [
                  {
                      title: 'Impersonate User',
                      to: navigate.paths.impersonateUser(),
                  },
              ]
            : []),
        {
            title: 'Logout',
            onClick: () => showConfirmation(true),
        },
    ];

    // Custom user avatar component
    const UserAvatar = () => (
        <div className='flex h-5 w-5 items-center justify-center rounded-full bg-sidebar-primary text-sidebar-primary-foreground text-[10px] font-medium absolute'>
            {initials || '-'}
        </div>
    );

    return (
        <>
            <NestedSidebarMenuItem
                label={fullName}
                icon={<UserAvatar />}
                isActive={false}
                subItems={subItems}
                collapsedButtonClassName='!w-[40px] !h-[40px] p-0'
                labelClassName='ml-7'
            />

            <Dialog open={shouldShowConfirmation} onOpenChange={open => !open && showConfirmation(false)}>
                <DialogContent>
                    <DialogTitle className='p-0'>Are you sure you want to Sign Out?</DialogTitle>
                    <DialogFooter className='p-0 pt-4'>
                        <TertiaryButton onClick={() => showConfirmation(false)}>Cancel</TertiaryButton>
                        <PrimaryButton onClick={signout}>Sign Out</PrimaryButton>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default UserMenu;
